// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    batch_billed_text: 'Segnare come fatturato',
};
